module.exports = __webpack_public_path__ + "static/media/polus3.612723cb.jpg";